export const PATH = {
    WASTE : '/services/waste',
    WASTE_DETAILS : '/waste',
    WASTE_CARD_CREATE : '/waste-card-create',
    WASTE_CARD_EDIT : '/waste-card-edit',
    WASTE_REGISTER : '/waste-register',
    WASTE_REGISTER_SUCCESS : '/waste-register-success',
    WASTE_RECORD_FORM : '/waste-form',
    WASTE_FORWARD : '/forward-waste',
}